export default "__VITE_ASSET__m5AVc6TK__"